

const API_URL = "https://natuf-v2.anantacore.com/api/public";
export default API_URL;// dont touch this

